import React from "react";
import { IntersectionRuleBuilder } from "../IntersectionRuleBuilder";
import { getEmptyRuleDefinition } from "../Testing/TestDataSetup";
import { getEmptyDataDefinition, getFilledDataDefinition } from "../../../rule-engine-core/Common/Data/DataTestData";

import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";

export const IntersectionRuleStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleDefinition();
            ruleDefinition.inputData = getEmptyDataDefinition();
            return <IntersectionRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Intersection Rule",
        "Empty Input Data",
    ),

    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleDefinition();
            ruleDefinition.inputData = getFilledDataDefinition();
            return <IntersectionRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Intersection Rule",
        "With Input Data",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleDefinition();
            ruleDefinition.inputData = () => getFilledDataDefinition();
            return <IntersectionRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Intersection Rule",
        "Read Only Input Data",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleDefinition();
            ruleDefinition.inputData = () => getFilledDataDefinition();
            ruleDefinition.executionResult = () => {
                return new StringDataDefinition();
            };
            return <IntersectionRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Intersection Rule",
        "Read Only Output",
    ),
];
